import React, { useState } from "react";
import { useFormik } from "formik";
import "./index.css";
import "../../custome.style.css";
import { Button, Form, FormGroup, Input } from "reactstrap";
import { forgotPassword } from "../../api/auth";
import { formikForgotPass } from "./Constant";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import Loader from "../../components/Loader/Loader";
import { failed, success } from "../../utils/Tostify";

function ForgotPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formik = useFormik({
    ...formikForgotPass,
    onSubmit: async (values) => {
      let res;
      try {
          setIsLoading(true);
          res = await forgotPassword({ values, dispatch });
          if (res?.status === "SUCCESS") {
              setIsLoading(false);
              success(res?.message);
              navigate("/forgot-home");
          }else{
            setIsLoading(false);
            failed(res?.data);
          }
      } catch (error) {
          setIsLoading(false);
          failed(res?.message);
      }
    }
  });

  return (
    <>
      {isLoading ? <Loader/> : null}
      <div className="page-wrapper full-page">
        <div className="header-wrapper w-nav">
          <div className="container-default w-container">
            <div className="header-content-wrapper">
              <div className="header-middle header-v3">
                <a>
                <img src="/assets/icons/group_logo_carematics.svg" alt="text_logo" className="logo_png" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="section sign-in-section">
          <div className="image-container sign-in-section">
            <div className="image-wrapper shape section-hero---sign-in---shape-01">
              <img
                src="/assets/icons/WELCOME-YELLOW-CIRCLE.svg"
                alt=""
              />
            </div>
            <div className="position-absolute sign-in-shape-wrapper">
              <div className="image-wrapper shape section-hero---sign-in---shape-02">
                <img
                  src="/assets/icons/WELCOME-BLUE-LINES.svg"
                  alt=""
                />
              </div>
              <div className="image-wrapper transform-origin-bottom">
                <img
                  src="/assets/icons/WELCOME-RED-CIRCLE.svg"
                  alt=""
                />
              </div>
              <div className="image-wrapper">
                <img
                  src="/assets/icons/WELCOME-RECTANGLE.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="container-default z-index-1 width-100 w-container">
            <div className="inner-container _640px center">
              <div className="text-center mg-bottom-48px forgot">
                <h1 className="display-1 mg-bottom-8px welcom_blk forgot">
                  Forgot your Password
                </h1>
                <p className="color-neutral-700 mg-bottom-0 welcom_desc">
                  Please enter the email address associated with your account
                </p>
              </div>
              <div className="card sign-up-form shadow-02 w-form login_form">
                <Form onSubmit={formik.handleSubmit} className="form_block">
                  <FormGroup className="spacing_three">
                    <Input
                      id="exampleEmail"
                      name="email"
                      placeholder="Email"
                      type="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                    />
                    <img src="/assets/icons/welcom-email.svg" alt="text_logo" />
                    {formik.touched["email"] && formik.errors["email"] ? <span style={{color : "red"}}>{formik.errors["email"]}</span> : null}
                  </FormGroup>
                  <Button type="submit"  className="spacing_five">
                    Submit
                  </Button>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <p>Copyright © 2024 AimCare LLC</p>
        </footer>
      </div>
    </>
  );
}

export default ForgotPassword;
